export default {"src":"/_next/static/media/havas.105bce9b.svg","height":25,"width":110,"blurWidth":0,"blurHeight":0};